


export class LoteIntegracaoMigo {
  "arquivoLote";
  "status";
  "dataCadastro";
  "numeroChamadoMySuporte";
  "dataAlteracao";
  "id";
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `LoteIntegracaoMigo`.
   */
  static getModelName() {
    return "LoteIntegracaoMigo";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of LoteIntegracaoMigo for dynamic purposes.
  **/
  static factory(data) {
    return new LoteIntegracaoMigo(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'LoteIntegracaoMigo',
      plural: 'LoteIntegracaoMigos',
      path: 'LoteIntegracaoMigos',
      properties: {
        "arquivoLote": {
          name: 'arquivoLote',
          type: 'string'
        },
        "status": {
          name: 'status',
          type: 'string'
        },
        "dataCadastro": {
          name: 'dataCadastro',
          type: 'Date'
        },
        "numeroChamadoMySuporte": {
          name: 'numeroChamadoMySuporte',
          type: 'string'
        },
        "dataAlteracao": {
          name: 'dataAlteracao',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/LoteIntegracaoMigo.js